import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import decode from 'jwt-decode';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: {
      display: false,
    },
    header: {
      display: false,
      mode: 'default',
    },
    footer: {
      display: false,
      mode: 'default',
    },
    modal: {
      display: false,
      target: '',
    },
    home: {},
    prelude: {
      context: 'login',
    },
    editor: {
      actual: null,
      sites: {},
    },
    context: JSON.parse(localStorage.getItem('user-context')) || {
      id: null,
      name: '',
      email: '',
      company: null,
      iat: null,
      exp: null,
      settings: {},
    },
    auth: {
      token: localStorage.getItem('user-token') || '',
      status: '',
    },
    notifications: {},
  },
  mutations: {
    TOGGLE_DISPLAY_LAYOUT(state, payload) {
      state.menu.display = payload.menu || false;
      state.header.display = payload.header || false;
      state.footer.display = payload.footer || false;
    },
    TOGGLE_DISPLAY_MODAL(state, payload) {
      if (typeof payload.display === 'boolean')
        state.modal.display = payload.display;
      if (typeof payload.target === 'string')
        state.modal.target = payload.target;
    },
    SWITCH_EDITOR_LAYOUT(state, payload) {
      state.header.mode = payload.headerMode;
      state.footer.mode = payload.footerMode;
    },
    CHANGE_SANDBOX(state, payload) {
      state.editor.actual = payload.actual;
    },
    UPDATE_CONTEXT(state, payload) {
      state.context = payload;
    },
    HOME_UPDATE() {},
    EDITOR_UPDATE(state, payload) {
      state.editor.sites = payload.websites;
    },
    PRELUDE_UPDATE_CONTEXT(state, payload) {
      state.prelude.context = payload;
    },
    AUTH_REQUESTING(state) {
      state.auth.status = 'loading';
    },
    AUTH_SUCCESS(state, token) {
      state.auth.token = token;
      state.auth.status = 'success';
    },
    AUTH_ERROR(state) {
      state.auth.status = 'error';
    },
    AUTH_LOGOUT(state) {
      state.auth.status = '';
      state.auth.token = '';
    },
    PUSH_NOTIFICATION(state, payload) {
      Vue.set(state.notifications, payload.id, payload.message);
    },
    POP_NOTIFICATION(state, payload) {
      delete state.notifications[payload];
      state.notifications = { ...state.notifications };
    },
  },
  actions: {
    async HOME_CONTEXT_REQUEST({ commit }) {
      try {
        commit('HOME_UPDATE');
      } catch (err) {
        console.warn(err);
        throw err;
      }
    },
    async EDITOR_CONTEXT_REQUEST({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SITE_API_URL}/api/editor`
        );
        commit('EDITOR_UPDATE', { websites: response.data.entities.websites });
        return response;
      } catch (err) {
        console.warn(err);
        throw err;
      }
    },
    async AUTH_REQUEST({ commit }, user) {
      try {
        commit('AUTH_REQUESTING');
        const userAgent = window.navigator.userAgent || '';
        // Windows 7 === Windows NT 6.1
        const isWindows7 = userAgent.search('Windows NT 6.1') !== -1;
        if (isWindows7) {
          throw new Error(
            'Você está tentando acessar o editor através do Windows 7, que é ultrapassado e por isso não comporta as funcionalidades disponíveis.\n Acesse de um sistema mais moderno, como o Windows 8, 10, linux, mac ou similares.'
          );
        }
        const response = await axios.post(
          `${process.env.VUE_APP_ADMIN_API_URL}/users.login`,
          user
        );
        const token = response?.data?.token;

        if (!token) throw new Error('Email e/ou senha inválido(s)');

        const context = decode(token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('user-token', token);
        localStorage.setItem('user-context', JSON.stringify(context));
        commit('AUTH_SUCCESS', token);
        commit('UPDATE_CONTEXT', context);
        return response;
      } catch (err) {
        console.warn(err.message);
        commit('AUTH_ERROR', err);
        localStorage.removeItem('user-token');
        localStorage.removeItem('user-context');
        throw err;
      }
    },
    async AUTH_LOGOUT({ commit }) {
      commit('AUTH_LOGOUT');
      delete axios.defaults.headers.common['Authorization'];
      localStorage.removeItem('user-token');
      localStorage.removeItem('user-context');
      return;
    },
    ALERT({ commit }, message) {
      const id = Math.floor(Math.random() * 10000000);
      commit('PUSH_NOTIFICATION', { id, message });
      setTimeout(() => {
        commit('POP_NOTIFICATION', id);
      }, 4000);
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.auth.token,
    authStatus: (state) => state.auth.status,
  },
});
